module.exports = __webpack_public_path__ + "img/rule_bg_2.81c87cf7.png";